import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable, of, throwError } from 'rxjs';
import { switchMap, tap, map, catchError } from 'rxjs/operators';
import { SellerAccountView } from '../../../core/model/seller-account-view.model';
import { BuyerAccountView } from '../../../core/model/buyer-account-view.model';
import { Input } from '@angular/core';
import { MainService } from '../../../children/main/main.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class LemonwayOnboardingService {
    private baseUrl = '/lemonway-onboarding';

    constructor(private _httpService: FlamingoHttpService, private _mainService: MainService, private _snackBar: MatSnackBar) {
        // Debug: vediamo come FlamingoHttpService gestisce gli URL
        // console.log('FlamingoHttpService:', this._httpService);
    }

    createAccount(sellerId: number): Observable<any> {
        return this._httpService.post(`${this.baseUrl}/create-account/${sellerId}`, {});
    }
    initiateOnboarding(sellerId: number): Observable<any> {
        return this._httpService.post(`${this.baseUrl}/initiate-onboarding/${sellerId}`, {});
    }
    getResumeUrl(sellerId: number): Observable<any> {
        return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`).pipe(
            map((response: any) => {
                let parsedResponse = response;
                if (typeof response === 'string') {
                    try {
                        parsedResponse = JSON.parse(response);
                    } catch (e) {
                        console.error('[ERROR] Impossibile fare il parse della risposta:', response);
                        return;
                    }
                }
                const url = parsedResponse.url;
                console.log('[DEBUG] URL:', url, 'parsedResponse:', parsedResponse);
                if (url) {
                    const newWindow = window.open(url, '_blank');
                    if (!newWindow) {
                        this._snackBar.open('Il browser ha bloccato l\'apertura della nuova scheda. Per favore, controlla le impostazioni.', 'Chiudi', { duration: 5000 });
                    }
                }
            })
        );
    }

    /* 
        startOnboarding(sellerId: number): Observable<any> {
            console.log('[DEBUG] Starting onboarding for sellerId:', sellerId);
            const user = this._mainService.user as SellerAccountView;
            const hasAccountId = !!user?.onboardingAccountId;
            const hasProfileId = !!user?.onboardingId;
            if (!hasAccountId && !hasProfileId) {
                // Nessuno dei due: create, initiate, resume
                console.log('[DEBUG] Starting onboarding for sellerId CASE 1:', sellerId);
                return this._httpService.post(`${this.baseUrl}/create-account/${sellerId}`, {})
                    .pipe(
                        switchMap(errors => {
                            if (errors && errors.length > 0) {
                                return of({ errors });
                            }
                            return this._httpService.post(`${this.baseUrl}/initiate-onboarding/${sellerId}`, {});
                        }),
                        catchError(error => {
                            if (error?.errorObj?.error?.message) {
                                throw new Error(error.errorObj.error.message);
                            }
                            throw error;
                        }),
                        /* switchMap(initiateErrors => {
                            if (initiateErrors && initiateErrors.length > 0) {
                                return of({ errors: initiateErrors });
                            }
                            return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`);
                        }) 
                    );
            } else if (hasAccountId && !hasProfileId) {
                // Solo accountId: initiate, resume
                console.log('[DEBUG] Starting onboarding for sellerId CASE 2:', sellerId);
                return this._httpService.post(`${this.baseUrl}/initiate-onboarding/${sellerId}`, {})
                    .pipe(
                        catchError(error => {
                            if (error?.errorObj?.error?.message) {
                                throw new Error(error.errorObj.error.message);
                            }
                            throw error;
                        }),
                        /*  switchMap(initiateErrors => {
                             if (initiateErrors && initiateErrors.length > 0) {
                                 return of({ errors: initiateErrors });
                             }
                             return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`);
                         }) 
                    );
            } else {
                // Entrambi presenti: solo resume
                /*  console.log('[DEBUG] Starting onboarding for sellerId CASE 3:', sellerId);
                 return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`); 
            }
        }
    
        resumeOnboarding(sellerId: number): Observable<string> {
            const user = this._mainService.user as SellerAccountView;
            const hasAccountId = !!user?.onboardingAccountId;
            const hasProfileId = !!user?.onboardingId;
            console.log('[DEBUG] hasAccountId:', hasAccountId);
            console.log('[DEBUG] hasProfileId:', hasProfileId);
            if (hasAccountId && !hasProfileId) {
                // Solo accountId: initiate, resume
                console.log('[DEBUG] Starting onboarding for sellerId CASE 2:', sellerId);
                return this._httpService.post(`${this.baseUrl}/initiate-onboarding/${sellerId}`, {})
                    .pipe(
                        catchError(error => {
                            if (error?.errorObj?.error?.message) {
                                throw new Error(error.errorObj.error.message);
                            }
                            throw error;
                        }),
                        switchMap(initiateErrors => {
                            if (initiateErrors && initiateErrors.length > 0) {
                                return of({ errors: initiateErrors });
                            }
                            return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`);
                        })
                    );
            } else {
                // Entrambi presenti: solo resume
                console.log('[DEBUG] Starting onboarding for sellerId CASE 3:', sellerId);
                return this._httpService.getUrl(`${this.baseUrl}/${sellerId}/resume`);
            }
        } */

    resumeOnboarding(sellerId: number): Observable<string> {
        return this._httpService.get(`${this.baseUrl}/${sellerId}/resume`)
            .pipe(
                map((response: any) => {
                    console.log('[DEBUG] Resume onboarding response:', response);
                    return response.url;
                }),
                tap(url => console.log('[DEBUG] Resume URL:', url))
            );
    }

    // ONBOARDING BUYER
    startBuyerOnboarding(buyerId: number): Observable<any> {
        return this._httpService.post(`${this.baseUrl}/create-account-buyer/${buyerId}`, {})
            .pipe(
                tap(response => console.log('[DEBUG] Create account response (buyer):', response)),
                switchMap(errors => {
                    if (errors && errors.length > 0) {
                        return of({ errors });
                    }
                    return this._httpService.post(`${this.baseUrl}/initiate-onboarding-buyer/${buyerId}`, {})
                        .pipe(
                            catchError(error => {
                                if (error?.errorObj?.error?.message) {
                                    throw new Error(error.errorObj.error.message);
                                }
                                throw error;
                            }),
                            switchMap(initiateErrors => {
                                if (initiateErrors && initiateErrors.length > 0) {
                                    return of({ errors: initiateErrors });
                                }
                                return this._httpService.getUrl(`${this.baseUrl}/${buyerId}/resume-buyer`);
                            })
                        );
                })
            );
    }

    resumeBuyerOnboarding(buyerId: number): Observable<string> {
        return this._httpService.get(`${this.baseUrl}/${buyerId}/resume-buyer`)
            .pipe(
                map((response: any) => {
                    console.log('[DEBUG] Resume onboarding response (buyer):', response);
                    return response.url;
                }),
                tap(url => console.log('[DEBUG] Resume URL (buyer):', url))
            );
    }

} 
